import React, { useState } from 'react';
import { Star, ChevronLeft, ChevronRight, Quote, MapPin, CheckCircle } from 'lucide-react';
import mahima from "../Assets/mahima1.jpeg"

// Customer Photos/Avatars - Using initials with colors for simplicity
const customerPhotos = {
  'RM': 'https://media.istockphoto.com/id/1961053928/photo/testimonial-portrait-of-a-handsome-mature-man.jpg?s=612x612&w=0&k=20&c=MJq7K4S8Hihi7p4f4-Ja4_II9X8HRsBGusOcJ7uJLbc=',
  'PR': 'https://i.ytimg.com/vi/Ykegxv5rcy8/hqdefault.jpg',
  'AK': 'https://lirp.cdn-website.com/6f140169/dms3rep/multi/opt/Parikshit+Gokhale-640w.jpg',
  'SI': 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS1tvUa4P77XV2h_-Z2846T83Ablpix4R1Kjg&s',
  'VS': 'https://i.ytimg.com/vi/kh0otp5zZRo/hq720.jpg?sqp=-oaymwEhCK4FEIIDSFryq4qpAxMIARUAAAAAGAElAADIQj0AgKJD&rs=AOn4CLCjnb5GwO9kPNXbWzgK7ryBddWGTA',
  'AG': 'https://rksmhrnetworks.com/assets/images/testimonials/img2.jpg',
  'SK': mahima,
  'NK': 'https://thumbs.dreamstime.com/b/male-blogger-recording-video-review-smart-watch-blogging-videoblog-people-concept-smiling-indian-home-153656216.jpg',
  'MP': 'https://media.istockphoto.com/id/1135381173/photo/portrait-of-a-young-man-outdoors-smiling.jpg?s=612x612&w=0&k=20&c=J8DKGHI8o-oj8cY1CCNpFY2V9OmVVbJuKSO2DdbMvRg=',
  'RK': 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRr4y0lMNHQZLU1Rl9hGF_QfZDMb5Z9fg1mKA&s',
  'PD': 'https://www.iicd.ac.in/wp-content/uploads/2024/05/YashviBaxi_FMA_2014-18_IICD-960x720.jpg',
  'MK': 'https://viacomindias3.s3.amazonaws.com/category/Testimonial/Pardeep_tiwari.jpg',
  'SG': 'https://i.ytimg.com/vi/pzf56AugI-s/maxresdefault.jpg',
  'VS2': 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS1zwLQfxV6xdJPKCy3qREddBCoW8aZ4L7nzg&s',
  'PP': 'https://plus.unsplash.com/premium_photo-1682089787056-9ac0c78a2ac2?fm=jpg&q=60&w=3000&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NXx8aW5kaWFuJTIwcGVvcGxlfGVufDB8fDB8fHww'
};

// Testimonials Data with 15 entries
const testimonials = [
  {
    id: 1,
    name: "Rahul Mehta",
    role: "Customer, rented a Traveler",
    rating: 5,
    date: "1 week ago",
    content: "We booked a Tempo Traveller for our Tirupati Balaji trip. The cab was clean, the driver was punctual and polite, and the whole journey was very comfortable. I will definitely book again",
    avatar: "RM",
    location: "Ramesh Iyer, Chennai",
    trips: 50,
    verified: true
  },
  {
    id: 2,
    name: "Pooja Sharma, Hyderabad",
    role: "Great service and professional staff!",
    rating: 5,
    date: "3 days ago",
    content: "I hired Shree Puja Travels for my wedding guests transportation in Hyderabad. Everything was well managed, and the drivers were courteous. Highly recommended!",
    avatar: "PR",
    location: "Hyderabad",
    trips: 12,
    verified: true
  },
  {
    id: 3,
    name: "Ankit Patel, Ahmedabad",
    role: "Perfect for family travel!",
    rating: 5,
    date: "Yesterday",
    content: "We recently went on a family trip to Ooty. The Ertiga was spacious and the journey was smooth. Thank you for making our vacation stress-free.",
    avatar: "AK",
    location: "Ahmedabad",
    trips: 25,
    verified: true
  },
  {
    id: 4,
    name: "Sana Khan, Mumbai",
    role: "Customer, rented a SUV",
    rating: 4,
    date: "2 weeks ago",
    content: "I had to travel from Mumbai to Nashik for an urgent meeting. Booked a one-way cab through Shree Puja Travels—on-time pickup and reasonable pricing. Really impressed.",
    avatar: "SI",
    location: "Mumbai",
    trips: 18,
    verified: true
  },
  {
    id: 5,
    name: "Vijay Thakur, Delhi",
    role: "Customer, rented a Sedan",
    rating: 5,
    date: "4 days ago",
    content: "Our Char Dham Yatra with Shree Puja Travels was divine and well-organized. The driver was experienced and took care of all our needs throughout the trip.",
    avatar: "VS",
    location: "Delhi",
    trips: 32,
    verified: true
  },
  {
    id: 6,
    name: "Anand & Meena Sharma",
    role: "Anand & Meena Sharma",
    rating: 5,
    date: "1 week ago",
    content: "We booked a five-day outstation trip with Shree Puja Travels, and it was a fantastic experience. The driver was courteous, patient, and ensured our comfort throughout the journey. The car was spacious and well-maintained, making our trip smooth and enjoyable. Thank you for such excellent service!",
    avatar: "AG",
    location: "Madhapur",
    trips: 8,
    verified: true
  },
  {
    id: 7,
    name: "Dr. Mahima Dand",
    role: "Customer, rented a SUV",
    rating: 5,
    date: "5 days ago",
    content: "Shree Puja Travels stands out as one of the finest travel services available in Hyderabad. As someone visiting from another city, I found the entire experience exceptionally comfortable and hassle-free. The level of care and attention to detail provided is truly top-class. The vehicle was impeccably clean, well-maintained, and personally managed, offering a sense of reliability and warmth. Safety is clearly a top priority, which adds to the peace of mind while traveling. Without a doubt, Shri Puja Travels is the best choice in Hyderabad, and I would confidently recommend their services to anyone seeking quality and professionalism.",
    avatar: "SK",
    location: "Kukatpally",
    trips: 45,
    verified: true
  },
  {
    id: 8,
    name: "Surendra Rao",
    role: "Customer, rented a Sedan",
    rating: 5,
    date: "3 weeks ago",
    content: "As a senior citizen, I appreciate punctual and reliable service, and Shree Puja Travels exceeded my expectations. Our five-day trip was stress-free, the driver assisted us at every stop, and the car was incredibly comfortable. I highly recommend them for long journeys!",
    avatar: "NK",
    location: "Begumpet",
    trips: 6,
    verified: true
  },
  {
    id: 9,
    name: "Rajesh Kumar",
    role: "Customer, rented a Sedan",
    rating: 4,
    date: "1 month ago",
    content: "I had an amazing experience with Shree Puja Travels. The car was in excellent condition, and the chauffeur was very professional.The entire process was smooth and hassle-free. Highly recommended!",
    avatar: "MP",
    location: "Banjara Hills",
    trips: 15,
    verified: true
  },
];

const SimpleTestimonialSection = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [testimonialsPerPage, setTestimonialsPerPage] = useState(() => {
    // Set responsive testimonials per page
    if (typeof window !== 'undefined') {
      if (window.innerWidth < 768) return 1;
      if (window.innerWidth < 1024) return 2;
      return 3;
    }
    return 3;
  });

  React.useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setTestimonialsPerPage(1);
      } else if (window.innerWidth < 1024) {
        setTestimonialsPerPage(2);
      } else {
        setTestimonialsPerPage(3);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const nextSlide = () => {
    const maxIndex = Math.ceil(testimonials.length / testimonialsPerPage) - 1;
    if (currentIndex < maxIndex) {
      setCurrentIndex(currentIndex + 1);
    }
  };

  const prevSlide = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
    }
  };

  const goToSlide = (index) => {
    const maxIndex = Math.ceil(testimonials.length / testimonialsPerPage) - 1;
    if (index >= 0 && index <= maxIndex) {
      setCurrentIndex(index);
    }
  };

  const StarRating = ({ rating }) => {
    return (
      <div className="flex">
        {[...Array(5)].map((_, i) => (
          <Star
            key={i}
            size={16}
            className={`${i < rating ? 'fill-yellow-400 text-yellow-400' : 'text-gray-300'}`}
          />
        ))}
      </div>
    );
  };

  // Calculate visible testimonials
  const startIndex = currentIndex * testimonialsPerPage;
  const visibleTestimonials = testimonials.slice(startIndex, startIndex + testimonialsPerPage);

  return (
    <div className="py-16 px-6 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            What Our Customers Say
          </h2>
          <p className="text-gray-600 text-lg max-w-2xl mx-auto">
            Join 500+ happy customers who trust Shree Puja Travels for their daily commute and outstation trips
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="relative">
          {/* Navigation Buttons */}
          <button
            onClick={prevSlide}
            disabled={currentIndex === 0}
            className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-4 md:-translate-x-6 z-10 p-3 bg-white rounded-full shadow-lg hover:shadow-xl disabled:opacity-50 disabled:cursor-not-allowed transition-all"
          >
            <ChevronLeft className="text-gray-700" size={24} />
          </button>
          
          <button
            onClick={nextSlide}
            disabled={currentIndex >= Math.ceil(testimonials.length / testimonialsPerPage) - 1}
            className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-4 md:translate-x-6 z-10 p-3 bg-white rounded-full shadow-lg hover:shadow-xl disabled:opacity-50 disabled:cursor-not-allowed transition-all"
          >
            <ChevronRight className="text-gray-700" size={24} />
          </button>

          {/* Testimonials Container */}
          <div className="overflow-hidden">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {visibleTestimonials.map((testimonial) => (
                <div 
                  key={testimonial.id} 
                  className="bg-white rounded-2xl shadow-lg hover:shadow-xl transition-shadow h-full p-6"
                >
                  {/* Quote Icon */}
                  <div className="mb-4">
                    <Quote className="text-gray-900 opacity-20" size={32} />
                  </div>

                  {/* Rating */}
                  <div className="mb-4">
                    <StarRating rating={testimonial.rating} />
                  </div>

                  {/* Content */}
                  <p className="text-gray-700 mb-6 line-clamp-4">
                    "{testimonial.content}"
                  </p>

                  {/* Customer Info */}
                  <div className="flex items-center gap-3">
                    {/* Customer Photo */}
                    <div className="relative">
                      <img 
                        src={customerPhotos[testimonial.avatar]} 
                        alt={testimonial.name}
                        className="w-12 h-12 rounded-full border-2 border-white shadow-md object-cover"
                        onError={(e) => {
                          e.target.src = `https://ui-avatars.com/api/?name=${testimonial.name}&background=random&color=fff`;
                        }}
                      />
                      {testimonial.verified && (
                        <div className="absolute -bottom-1 -right-1 w-5 h-5 bg-green-500 rounded-full flex items-center justify-center">
                          <CheckCircle size={12} className="text-white" />
                        </div>
                      )}
                    </div>

                    <div className="flex-1">
                      <div className="flex items-center justify-between">
                        <div>
                          <h4 className="font-semibold text-gray-900">{testimonial.name}</h4>
                          <p className="text-gray-600 text-sm">{testimonial.role}</p>
                        </div>
                        <div className="text-right">
                          <div className="flex items-center gap-1 text-sm text-gray-500">
                            <MapPin size={12} />
                            <span>{testimonial.location}</span>
                          </div>
                          <div className="text-gray-500 text-xs mt-1">
                            {testimonial.trips} trips
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Date */}
                  <div className="mt-4 pt-4 border-t border-gray-100">
                    <span className="text-gray-500 text-sm">{testimonial.date}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Dots Navigation */}
        <div className="flex justify-center gap-2 mt-8">
          {Array.from({ length: Math.ceil(testimonials.length / testimonialsPerPage) }).map((_, idx) => (
            <button
              key={idx}
              onClick={() => goToSlide(idx)}
              className={`w-2 h-2 rounded-full transition-all ${
                idx === currentIndex 
                  ? 'w-8 bg-gradient-to-r from-gray-900 to-gray-900' 
                  : 'bg-gray-300 hover:bg-gray-400'
              }`}
            />
          ))}
        </div>

        {/* Show More Button */}
        <div className="text-center mt-12">
          <button className="px-8 py-3 text-white rounded-full hover:shadow-lg transition-all font-semibold" style={{ backgroundColor: 'rgba(65, 1, 150, 1)' }}>
            View All Testimonials
          </button>
        </div>
      </div>
    </div>
  );
};

export default SimpleTestimonialSection;